import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";

const menus = [
    {
        id: 1,
        title: 'Send Money',
        link: '/home',
        submenu: [
            {
                id: 11,
                title: 'India',
                link: '/send-money-to-india'
            },
            {
                id: 12,
                title: 'Pakistan',
                link: '/send-money-to-pakistan'
            },
            {
                id: 13,
                title: 'Bangladesh',
                link: '/send-money-to-bangladesh'
            },
            {
                id: 14,
                title: 'Nepal',
                link: '/send-money-to-nepal'
            },
            // {
            //     id: 15,
            //     title: 'Nigeria',
            //     link: '/send-money-to-nigeria'
            // },
            {
                id: 16,
                title: 'Srilanka',
                link: '/send-money-to-srilanka'
            },
            // {
            //     id: 17,
            //     title: 'Malaysia',
            //     link: '/send-money-to-malaysia'
            // },
            // {
            //     id: 18,
            //     title: 'Philipines',
            //     link: '/send-money-to-philipphins'
            // },
        ]
    },
    {
        id: 3,
        title: 'Help',
        link: '/help',
        
    },
    {
        id: 4,
        title: 'Refer & Earn',
        link: '/refer-and-earn',
        
    },
    {
        id: 5,
        title: 'Contact Us',
        link: '/contact-us',
        
    },
    

]

const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <ul className="xb-menu-primary clearfix">
            {menus.map((item, mn) => {
                return (
                    <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                        {item.submenu ?
                            <Fragment>
                                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                </p>
                                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                    <List className="menu-item menu-item-has-children active">
                                        <Fragment>
                                            {item.submenu.map((submenu, i) => {
                                                return (
                                                    <ListItem key={i}>
                                                        <Link onClick={ClickHandler} className="active"
                                                            to={submenu.link}>{submenu.title}</Link>
                                                            
                                                    </ListItem>
                                                )
                                            })}
                                        </Fragment>
                                    </List>
                                    <br></br>
                                  
                                </Collapse>
                                
                                
                            </Fragment>
                            : <Link className="active"
                                to={item.link}>{item.title}</Link>
                        }
                    </ListItem>
                )
            })}
        </ul>
    )
}

export default MobileMenu;